import type { FaireProductEntity } from "../../entity_types/product";

export const p_ddy3uw8rep: FaireProductEntity = {
  token: "p_ddy3uw8rep",
  type: "product",
  name: "50 Feminism Ideas You Ready Need to Know",
  brandToken: "b_bomzcs63",
  brandName: "Hachette Book Group",
  imageUrl: "https://cdn.faire.com/fastly/2d18e30ad8496897cce7e609db94d6602cc471774d2ede03d5812d883040cea0.jpeg",
  galleryImageUrls: [],
  priceDollars: 9.5,
  description: "Master the ideas that have shaped feminism throughout history.\n\nIn a series of 50 accessible essays, author and journalist Maya Oppenheim explores the history, ideas and battle grounds that have defined and divided feminist movements.\n\nWith writing that spans the worlds of pop culture, literature, theory, politics, economics, art, science, activism and technology, the book charts the trajectory of an eclectic movement, which has long strived to make the world a fairer and less brutal place.\n\nFrom the right to vote to reproductive rights, from protofeminist movements to psychoanalytical feminism, 50 Feminism Ideas You Really Need to Know is a comprehensive, readable introduction to the most important feminist ideas throughout history. Using her experience as the first and only Women's Correspondent at a UK news outlet, Maya also delves into a range of contemporary issues, which feminist movements wrestle with today as the far right swells in power and the backlash to women's rights intensifies.",
  tags: [],
  msrpDollars: 18.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:06:23.283Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
